<div class="btn m-0" [class.btn-sm]="sm" [class.btn-primary]="value" [class.btn-info-outline]="!value" [class.b-btn-slim]="slim" [class.disabled]="(disabled || readonly)" (click)="runUpdate()">
    <clr-icon [attr.shape]="value ? yesIcon : noIcon"></clr-icon>
</div>
